module.exports = __webpack_public_path__ + "img/WhatsApp-GraySquare-Logo.wine.4f6032e4.svg";